import React from 'react';
import Rater from 'react-rater';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

import { withRouter, RouteComponentProps } from 'react-router-dom';

import { makeUrl } from '@dom/utils';
import { onRequestPorterGuide } from '@dom/app/src/actions/analytics';

import { Tooltip } from '../../components';
import PorterGuideFAQModal from './PorterGuideFAQModal';
import { BlurImage, WhitePanelLayout, ShowReviews } from './imports';

import { useSelector } from '../../redux';
import { getGuideSearchQuery, getGuideDataById } from '../../redux/selectors';

import { getLocaleString, openInNewTab } from '../../utils';
import { GUIDE_INSURANCE_COST } from '../../constants';

import './guide.scss';

const porterGuideId = process.env.REACT_APP_PORTER_GUIDE_ID;

type Props = RouteComponentProps & {};

function PorterGuide(props: Props) {
  const {numberOfDays } = useSelector(getGuideSearchQuery) || {};

  const { dailyWages, averageRating, reviews, fullname } = useSelector(getGuideDataById(porterGuideId)) || {};
  const { currency, amount } = dailyWages || { currency: 'USD', amount: 0 };

  const porterGuideWage = amount ? Number(numberOfDays || 1) * amount + GUIDE_INSURANCE_COST : '';

  const imageStyles = {
    backgroundImage: "url('https://s3.amazonaws.com/honeyguide/assets/porter-guide.png')",
  };

  const priceBreakDown = `Price for ${numberOfDays || 1} Day${numberOfDays ? 's' : ''} is ${currency} ${getLocaleString(porterGuideWage)}`;
  const tooltipMessage = 'Includes Daily Wages, Insurance, Food and Accommodation Costs. Local transportation is not included.';

  const goToProfile = (e) => {
    e.stopPropagation();
    openInNewTab(makeUrl.goToGuideProfile(fullname, porterGuideId));
  }

  return (
    <div>
      <WhitePanelLayout className="grid-view">
        <div className="image-holder" style={imageStyles}>
          <BlurImage
            alt="Porter Guide"
            placeholder="https://s3.amazonaws.com/honeyguide/assets/porter-guide.png"
            src="https://s3.amazonaws.com/honeyguide/assets/porter-guide.png"
          />
        </div>
        <div className="information-box">
          <div className="detail-info">
            <div className="detail-holder">
              <h4>Porter-Guide</h4>
              <p>A Porter-Guide is someone who will carry your bags and show you the path while in the trails.</p>
              <div className="d-none d-md-block">
                <PorterGuideFAQModal />
                <ol>
                  <li>- Basic Guiding Skills</li>
                  <li>- Carries up to 15 kgs</li>
                  <li>- Limited First-Aid Skills</li>
                </ol>
              </div>
            </div>
            <div className="price-detail porter">
              <h4>
                {currency} {amount}/day
              </h4>
              <Tooltip info={tooltipMessage}>
                <div className="breakdown">
                  <span>{priceBreakDown}</span>
                  <em>i</em>{' '}
                </div>
              </Tooltip>
              <p className="breakdown" style={{ color: '#e91e63', textAlign: 'right', display: 'unset' }}>Free Cancellation within 7 days</p>
              <div className="wrap-t"></div>
              <Rater
                total={5}
                rating={Number(averageRating)}
                interactive={false}
              />
              <ShowReviews numReviews={reviews && reviews.numberOfReviews} />
              <Button color="yellow" size="sm" onClick={goToProfile}>
                View Profile
              </Button>
            </div>
            <div className="mobile-display d-block d-md-none">
              <PorterGuideFAQModal />
              <ol>
                  <li>- Basic Guiding Skills</li>
                  <li>- Carries up to 15 kgs</li>
                  <li>- Limited First-Aid Skills</li>
                </ol>
            </div>
          </div>
        </div>
      </WhitePanelLayout>
    </div>
  );
}

const ConnectedPorterGuide = connect(null, { onRequestPorterGuide })(PorterGuide)

export default withRouter(ConnectedPorterGuide);
